export default __webpack_public_path__ + "static/media/banner-img.5b8a76a9.png";